import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Drawer from 'material-ui/Drawer'
import { List, ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog'
// Icons
import DeleteIcon from 'material-ui-icons/Delete'
import ReportIcon from 'material-ui-icons/Report'
import PersonIcon from 'material-ui-icons/Person'
import BuildIcon from 'material-ui-icons/Code'

import {
  closeOverlay,
  ommitItem,
  overlapOpen,
  itemPriorityChange
} from './actions'

class OmmitOverlay extends Component {
  onDelete(data) {
    this.props.closeOverlay()
    var access_id = data['access id']
    let myComponent = this

    if (access_id) {
      //alert(access_id)
      let current_data = this.props.items_ommitted
      let new_data = {
        access_id: access_id
      }
      current_data.push(new_data)

      let current_data2 = this.props.priority_change_array
      const result = current_data2.find(
        item => item.access_id === data['access id']
      )
      if (result) {
        let index = current_data2.indexOf(result)
        current_data2.splice(index, 1)
      }
      let new_data2 = {
        access_id: access_id,
        new_priority: 5,
        color_id: 4
      }
      current_data2.push(new_data2)

      this.props.ommitItem(current_data)
      this.props.itemPriorityChange(current_data2)

      axios
        .get(
          'https://api.dsnapis.com/customer/' +
            this.props.customer_number +
            '/pw/teSt1/profileid/' +
            access_id +
            '/dscid/5/db/2'
        )
        .then(function(response) {
          //window.location.reload();
          //|| window.location.href.includes("console/search/all_candidates") || window.location.href.includes("console/search/saved_searches/results/")
          if (
            window.location.href.includes('console/display/rapid_display_view')
          ) {
            myComponent.props.overlapOpen(false, '0000')
          } /*
        else {
          alert("This candidate has been ommitted. Press ok to be taken back to the display options.")
          myComponent.props.changeRoute("https://dsn-app.firebaseapp.com/console/display");
        }
        */
        })
    } else {
      //alert('null')
    }
  }
  /*
    axios.post('https://api.dsnapis.com/customer/1/pw/teSt1/profileid/'+access_id+'/dscid/5/db/2', {
      omit: 'app'
    }).then(function (response) {
      console.log(response);
    }).catch(function (error) {
      console.log(error);
    });*/

  render() {
    const { classes, theme, location, overlayData } = this.props

    var localData = {}
    if (overlayData) {
      localData = overlayData
    }

    return (
      <div>
        <Dialog
          className={classes.root}
          open={this.props.overlayOpen}
          onRequestClose={() => this.props.closeOverlay()}
        >
          <DialogTitle>Delete this candidate?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this candidate? This action cannot
              be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={() => this.props.closeOverlay()}>
              No
            </Button>
            <Button
              color="primary"
              onClick={() => this.onDelete(localData)}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    router: state.router,
    overlayOpen: state.dashboard.ommitOverlayOpen,
    overlayData: state.dashboard.ommitData,
    items_ommitted: state.item_ommitted,
    priority_change_array: state.prioritychangeid
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url)),
    closeOverlay: data => dispatch(closeOverlay(data)),
    ommitItem: data => dispatch(ommitItem(data)),
    overlapOpen: data => dispatch(overlapOpen(data)),
    itemPriorityChange: data => dispatch(itemPriorityChange(data))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(OmmitOverlay)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/OmmitOverlay/index.js